import {api} from "./service.js";	
const index={
	//获取首页数据
	getIndexClass(pid){
		return api.post("pc/class/list",{pid:pid})
	},
	//首页品牌
	getIndexBrand(){
		return api.post("pc/brand/list")
	},
	//获取行业列表
	getIndustrys(){
		var list={
			"data": {
				"list": [
					{
						"id": "1",
						"title": "工业机器人",
						"pic": "/static/index/1.png",
						"width": 390,
						"height":308,
					},
					{
						"id": "2",
						"title": "日化",
						"pic": "/static/index/2.png",
						"width": 390,
						"height":545,
					},
					{
						"id": "3",
						"title": "智能家庭",
						"pic": "/static/index/3.png",
						"width": 390,
						"height":545,
					},
					{
						"id": "4",
						"title": "仓储物流",
						"pic": "/static/index/4.png",
						"width": 390,
						"height":546,
					},
					{
						"id": "5",
						"title": "乳品行业",
						"pic": "/static/index/5.png",
						"width": 390,
						"height":546,
					},
					{
						"id": "6",
						"title": "医药行业",
						"pic": "/static/index/6.png",
						"width": 390,
						"height":308,
					},
					{
						"id": "7",
						"title": "汽车行业",
						"pic": "/static/index/7.png",
						"width": 390,
						"height":546,
					},
					{
						"id": "8",
						"title": "机械设备制造",
						"pic": "/static/index/8.png",
						"width": 390,
						"height":308,
					},
					{
						"id": "9",
						"title": "电子行业",
						"pic": "/static/index/9.png",
						"width": 390,
						"height":546,
					}
				],
				"total": 9
			},
			"logid": 14762645,
			"errno": 0,
			"servertime": 1637306105,
			"errmsg": "success"
		}
		return list;
	},
	//获取目录
	getMulu(){
		var mulu=[
			{
			  'name':"产品",
			  'url':"/class/index/1",
			  'list':[
				  {
					'name':"RV减速机",
					'url':"/class/index/1",
					'list':[
						{
						  'name':"CT-CRV系列无法兰",
						  'url':"/goods/list/1/11/RV减速机"
						},
						{
						  'name':"CT-CRD系列有法兰",
						  'url':"/goods/list/1/12/RV减速机"
						}
					  ]
				  },
				//   {
				// 	'name':"RV减速机",
				// 	'url':"/class/index/1",
				// 	'list':[
				// 		{
				// 		  'name':"CT-CRV系列无法兰",
				// 		  'url':"/goods/list/1/11/RV减速机"
				// 		},
				// 		{
				// 		  'name':"CT-CRD系列有法兰",
				// 		  'url':"/goods/list/1/12/RV减速机"
				// 		}
				// 	  ]
				//   },
				  {
					'name':"行星减速机",
					'url':"/class/index/42",
					'list':[
						{
						  'name':"同心型减速机",
						  'url':"/goods/list/42/43/行星减速机"
						},
						{
						  'name':"直交型减速机",
						  'url':"/goods/list/42/44/行星减速机"
						}
					  ]
				  },
				  {
					'name':'伺服电机',
					'url':"/class/index/2",
					'list':[
						{
						  'name':"TDA040伺服电机",
						  'url':"/goods/list/2/13/伺服电机"
						},
						{
						  'name':"TDA060伺服电机",
						  'url':"/goods/list/2/14/伺服电机"
						},
						{
						  'name':"TDA080伺服电机",
						  'url':"/goods/list/2/15/伺服电机"
						},
						{
						  'name':"TDA130伺服电机",
						  'url':"/goods/list/2/16/伺服电机"
						},
						{
						  'name':"TDA180伺服电机",
						  'url':"/goods/list/2/17/伺服电机"
						}
					  ]
				  },
				  {
					'name':'伺服驱动器',
					'url':"/class/index/3",
					'list':[
						{
						  'name':"多轴伺服驱动器",
						  'url':"/goods/list/3/18/伺服驱动器"
						},
						{
							'name':"单轴伺服驱动器",
							'url':"/goods/list/3/21/单轴伺服驱动器"
						  }
					  ]
				  },
				  {
					'name':'并联机器人',
					'url':"/class/index/4",
					'list':[
						{
						  'name':"2自由度并联机器人",
						  'url':"/goods/list/4/22/并联机器人"
						},
						{
							'name':"3自由度并联机器人",
							'url':"/goods/list/4/23/并联机器人"
						},
						{
							'name':"4自由度并联机器人",
							'url':"/goods/list/4/24/并联机器人"
						},
						{
							'name':"5自由度并联机器人",
							'url':"/goods/list/4/27/并联机器人"
						},
						{
							'name':"6自由度并联机器人",
							'url':"/goods/list/4/28/并联机器人"
						}
					  ]
				  },
				  {
					'name':'串联机器人',
					'url':"/class/index/6",
					'list':[
						{
						  'name':"Scara机器人",
						  'url':"/goods/list/6/29/串联机器人"
						},
						{
							'name':"码垛机器人",
							'url':"/goods/list/6/30/串联机器人"
						}
					  ]
				  },
				  {
					'name':'协作机器人',
					'url':"/class/index/7",
					'list':[
						{
						  'name':"LM3轻型机器人",
						  'url':"/goods/list/7/31/协作机器人"
						},
						{
							'name':"协作机器人工作站",
							'url':"/goods/list/7/50/协作机器人"
						  }
					  ]
				  },
				  {
					'name':'真空元件',
					'url':"/class/index/8",
					'list':[
						{
						  'name':"真空吸盘",
						  'url':"/goods/list/8/32/真空元件"
						},
						{
							'name':"真空发生器",
							'url':"/goods/list/8/33/真空元件"
						  },
						  {
							'name':"真空吸具",
							'url':"/goods/list/8/45/真空元件"
						  },

					  ]
				  },



				  {
					'name':'控制系统',
					'url':"/class/index/9",
					'list':[
						{
						  'name':"并联机器人控制器",
						  'url':"/goods/list/9/34/控制系统"
						}
					  ]
				  },
				  {
					'name':'机器视觉系统',
					'url':"/class/index/10",
					'list':[
						{
						  'name':"2D视觉系统",
						  'url':"/goods/list/10/35/机器视觉系统"
						},
						{
							'name':"3D视觉系统",
							'url':"/goods/list/10/36/机器视觉系统"
						},
						{
							'name':"深度学习",
							'url':"/goods/list/10/37/机器视觉系统"
						}
					  ]
				  }				 
				],
			  'urllist':[
				'goodscompare',
				'goodsinfo',
				'goodslist',
				'classIndex'
			  ]
			},
			{
			  'name':"品牌",
			  'url':"/brand/list",
			  'urllist':[
				'brand',
				'brandList',
				'brandinfo'
			  ],
			  'list':[
				  {
					'name':'阿童木机器人',
					 'url':"/brand/index/1"
				  },
				  {
					'name':'合作品牌',
					'url':"/brand/list"
				  }
				]
			},
			{
			  'name':"服务行业",
			  'url':"/industry/index/1",
			  'urllist':['industryinfo'],
			  'list':[
				  {
					"name":"工业机器人零部件",
					'url':"/industry/index/1"
				  },
				  {
					"name":"消费品",
					'url':"/industry/index/2"
				  },
				  {
					"name":"商业智能服务",
					'url':"/industry/index/3"
				  },
				  {
					"name":"仓储物流",
					'url':"/industry/index/4"
				  },
				  {
					"name":"食品",
					'url':"/industry/index/5"
				  },
				  {
					"name":"医药",
					'url':"/industry/index/6"
				  },
				  {
					"name":"汽车及零部件",
					'url':"/industry/index/7"
				  },
				  {
					"name":"机械设备",
					'url':"/industry/index/8"
				  },
				  {
					"name":"电子",
					'url':"/industry/index/9"
				  },
				  {
					"name":"原材料加工",
					'url':"/industry/index/10"
				  },
				  {
					"name":"新能源",
					'url':"/industry/index/11"
				  }
				]
			},
			{
			  'name':"关于我们",
			  'urllist':['contacus'],
			  'url':"/user/contacus"
			},
			{
			  'name':"支持",
			  'urllist':["helpindex",'helpfqa','helppurchase','helpcooperation'],
			  'url':"/help/index"
			}
		  ];
		return mulu;
	},
	//获取自动化
	getAutoList(){
		var list = {
			"data": {
				"list": [
					{
						"id": "1",
						"title": "助力市场竞争",
						"des": "我们为您提供工业机器人领域全产业链商品,助力您的生产升级。",
						"pic": "/static/index/icon/icon1.png",
						"onpic": "/static/index/icon/onicon1.png",
					},
					{
						"id": "2",
						"title": "工业自动化",
						"des":"工业机器人逐渐成为工业生产中的主要力量，工业自动化大大提高了生产效率和数量。",
						"pic": "/static/index/icon/icon2.png",
						"onpic": "/static/index/icon/onicon2.png",
					},
					{
						"id": "3",
						"title": "全产业链商品",
						"des":"我们提供工业机器人制造所需核心零部件、丰富的工业机器人产品。",
						"pic": "/static/index/icon/icon3.png",
						"onpic": "/static/index/icon/onicon3.png",
					}
					,
					{
						"id": "4",
						"title": "助力您提升生产力",
						"des":"全球的工厂面临劳动力短缺，我们为您提供安全、高效、高性价比的自动化生产解决方案。",
						"pic": "/static/index/icon/icon4.png",
						"onpic": "/static/index/icon/onicon4.png",
					}
				],
				"total": 4
			},
			"logid": 14762645,
			"errno": 0,
			"servertime": 1637306105,
			"errmsg": "success"
		}
		return list;
	}
}
export default index;


// WEBPACK FOOTER //
// ./src/service/index.js